/* eslint-disable no-undef */
// Overlay batas timezone. GeoJSON-nya di-fetch sekali lalu disimpan di instance.
class TimezoneLayer {
  constructor({ map, onChange }) {
    this.map = map;
    this.onChange = onChange || (() => {});
    this.layer = null;
    this.visible = false;
    this.data = null;
    this.renderer = null;
  }

  async toggle(forceState) {
    this.visible = typeof forceState === 'boolean' ? forceState : !this.visible;
    if (!this.map) return;

    if (!this.visible) {
      if (this.layer && this.map.hasLayer(this.layer)) {
        this.map.removeLayer(this.layer);
      }
      this.onChange();
      return;
    }

    if (!this.layer) {
      try {
        if (!this.data) {
          const response = await fetch('/data/timezones.geojson');
          this.data = await response.json();
        }
        if (!this.renderer) {
          this.renderer = L.canvas({ padding: 0.5 });
        }
        this.layer = L.geoJSON(this.data, {
          renderer: this.renderer,
          style: {
            color: '#2563eb',
            weight: 1,
            opacity: 0.6,
            fillColor: '#3b82f6',
            fillOpacity: 0.04,
          },
          onEachFeature: (feature, layer) => {
            const props = feature.properties || {};
            const label = props.utc_format || 'Timezone';
            const places = props.places ? `<br><span style="color:#6b7280">${props.places}</span>` : '';
            layer.bindTooltip(`<strong>${label}</strong>${places}`, { sticky: true });
          },
        });
      } catch (error) {
        console.warn('Failed to load timezones layer:', error);
        this.visible = false;
        this.onChange();
        return;
      }
    }

    if (!this.map.hasLayer(this.layer)) {
      this.layer.addTo(this.map);
    }
    this.layer.bringToBack();
    this.onChange();
  }

  destroy() {
    this.map = null;
    this.layer = null;
    this.visible = false;
    this.data = null;
    this.renderer = null;
  }
}

export default TimezoneLayer;
